// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1o6Fr","notes":"Notes_notes__10uY1"};